import React from "react";

function SvgIcMapPoi049(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 32 32" {...props}>
      <g fill="none" fillRule="evenodd">
        <path
          d="M19.495 16.732c.415.738.752 1.528 1.044 2.324.553 1.506 1.11 3.352.923 4.976l.016-.12.009-.12-.003.133a1.379 1.379 0 01-.037.263c-.417 2.245-3.581 2.42-4.244.243-.308-.567-.826-1.322-1.563-.984-.683.316-.769 1.102-1.166 1.655-.895 1.24-2.774 1.18-3.596-.11-.234-.308-.332-.662-.354-1.04v-.02l-.006-.046c-.064-.682.047-1.431.167-2.113l.051-.288c.155-.855.386-1.696.69-2.508.29-.776.635-1.551 1.086-2.245 1.369-2.313 5.614-2.313 6.983 0zM10.53 23.98l.007.066.02.128-.027-.194zm-.009-.13l.001.036.001.026V23.933l.007.047-.005-.062-.004-.067zm14.215-13.805c1.13.283 1.716 1.836 1.309 3.469-.406 1.632-1.651 2.726-2.781 2.442-1.13-.283-1.716-1.837-1.31-3.467.407-1.633 1.653-2.728 2.782-2.444zm-17.473-.031c1.13-.283 2.376.808 2.782 2.434.406 1.627-.18 3.174-1.31 3.457-1.129.282-2.375-.808-2.78-2.434-.407-1.627.18-3.175 1.308-3.457zM13 6.009c1.105 0 2 1.347 2 3.009s-.895 3.009-2 3.009c-1.104 0-2-1.347-2-3.01 0-1.661.896-3.008 2-3.008zm5.999 0C20.103 6.01 21 7.34 21 8.982s-.897 2.973-2.001 2.973c-1.104 0-1.999-1.33-1.999-2.973 0-1.642.895-2.973 1.999-2.973z"
          fill="#FFF"
        />
      </g>
    </svg>
  );
}

export default SvgIcMapPoi049;
